var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.174,
    height: 14.38,
    viewBox: "0 0 19.174 14.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-volume-mute",
    "data-name": "Icon awesome-volume-mute",
    d: "M8.053,4.764,4.721,8.1H.9a.9.9,0,0,0-.9.9v5.393a.9.9,0,0,0,.9.9H4.721l3.332,3.331a.9.9,0,0,0,1.534-.635V5.4A.9.9,0,0,0,8.053,4.764Zm9.235,6.926L19,9.981a.6.6,0,0,0,0-.855l-.855-.855a.6.6,0,0,0-.855,0L15.579,9.981,13.869,8.272a.6.6,0,0,0-.855,0l-.855.855a.6.6,0,0,0,0,.855l1.709,1.709L12.161,13.4a.6.6,0,0,0,0,.855l.855.855a.6.6,0,0,0,.855,0L15.579,13.4l1.709,1.709a.6.6,0,0,0,.855,0L19,14.254a.6.6,0,0,0,0-.855Z",
    transform: "translate(0 -4.5)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.134e025bacb2684c5c86a8e10e8d17ce.svg";
export { ForwardRef as ReactComponent };